const keyMirror = require("keymirror");

module.exports = keyMirror({
  FILTER_GET_MATERIALS_FROM_SERVER_WILL: null,
  FILTER_GET_MATERIALS_FROM_SERVER_DID: null,
});
